import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import { post } from 'helpers/api_helper';
import Swal from 'sweetalert2';
import { showToast, showConfirm } from "../../../common/Toaster";

function* fetchBiometricDiscrepancySaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_BIOMETRIC_DISCREPANCY, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch biometric discrepancies!');
    }

    yield put({ type: types.FETCH_BIOMETRIC_DISCREPANCY_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_BIOMETRIC_DISCREPANCY_FAILURE, payload: error });
  }
}

function* fetchBiometricDevicePunchSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_BIOMETRIC_DEVICE_PUNCH, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch device punches!');
    }

    yield put({ type: types.FETCH_BIOMETRIC_DEVICE_PUNCH_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_BIOMETRIC_DEVICE_PUNCH_FAILURE, payload: error });
  }
}

function* saveBiometricDevicePunchSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_BIOMETRIC_DEVICE_PUNCH, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save device punch!');
    }

    yield put({ type: types.SAVE_BIOMETRIC_DEVICE_PUNCH_SUCCESS });
    Swal.fire('Success', 'Device Punch saved successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_BIOMETRIC_DEVICE_PUNCH_FAILURE, payload: error });
  }
}

function* discrepancyShiftUpdateSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DISCREPANCY_SHIFT_UPDATE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to update shift!");
    }

    yield put({ type: types.DISCREPANCY_SHIFT_UPDATE_SUCCESS, payload: response });
    Swal.fire("Success", "Shift updated successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.DISCREPANCY_SHIFT_UPDATE_FAILURE, payload: error });
  }
}

function* discrepancyPunchUpdateSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DISCREPANCY_PUNCH_UPDATE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to update punch!");
    }

    yield put({ type: types.DISCREPANCY_PUNCH_UPDATE_SUCCESS, payload: response });
    Swal.fire("Success", "Punch updated successfully!", "success");
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.DISCREPANCY_PUNCH_UPDATE_FAILURE, payload: error.message });
  }
}

function* saveShiftProcessEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_SHIFTPROCESS, action.payload);
    yield put({ type: types.SAVE_SHIFT_PROCESS_SUCCESS });
    Swal.fire('Success', response?.message, response?.status);
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_SHIFT_PROCESS_FAILURE, payload: error });
  }
}
//
function* saveShiftChangeEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_SHIFTCHANGE, action.payload);

    // Validate response
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Shift Change!");
    }

    // Dispatch success action
    yield put({ type: types.SAVE_SHIFT_CHANGE_SUCCESS, payload: response });

    // Success alert
    Swal.fire("Success", response?.message || "Shift Change saved successfully!", "success");
  } catch (error) {
    // Error alert
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving Shift Change!",
      icon: "error",
      confirmButtonText: "OK",
    });

    // Dispatch failure action
    yield put({ type: types.SAVE_SHIFT_CHANGE_FAILURE, payload: error });
  }
}

function* removeShiftEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_REMOVE_EMPLOYEE_SHIFT, action.payload);
    yield put({ type: types.REMOVE_SHIFT_SUCCESS });
    Swal.fire('Success', response?.message, response?.status);
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.REMOVE_SHIFT_FAILURE, payload: error });
  }
}

function* fetchShiftProcessEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_SHIFTPROCESS, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Shift Process!');
    }
    yield put({ type: types.FETCH_SHIFT_PROCESS_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SHIFT_PROCESS_FAILURE, payload: error });
  }
}

function* fetchShiftChangemployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_SHIFTCHANGE, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Shift Process!');
    }
    yield put({ type: types.FETCH_SHIFT_CHANGE_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SHIFT_CHANGE_FAILURE, payload: error });
  }
}

function* fetchEmployeeShiftCodeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_SHIFTCODE, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Shift Process!');
    }
    yield put({ type: types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_FAILURE, payload: error });
  }
}

function* fetchEmployeeShiftSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_SHIFTREMOVE, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Shift Process!');
    }
    yield put({ type: types.FETCH_SHIFT_REMOVE_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SHIFT_REMOVE_FAILURE, payload: error });
  }
}

// 🔹 Get Template Saga
function* punchlistGetTemplateSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_PUNCHLIST_GET_TEMPLATE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to download template!");
    }

    // ✅ Trigger file download
    if (response?.data) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${response.data}`; // full URL
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "EmployeePunchTemplate.xlsx"; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    Swal.fire("Success", "Template downloaded successfully!", "success");
    yield put({ type: types.PUNCHLIST_GET_TEMPLATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PUNCHLIST_GET_TEMPLATE_FAILURE, payload: error });
  }
}

// 🔹 Import Punchlist Saga
function* punchlistImportSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_PUNCHLIST_IMPORT,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to import Punchlist!");
    }

    // Swal.fire("Success", response.message || "Punchlist imported successfully!", "success");
    yield put({ type: types.PUNCHLIST_IMPORT_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PUNCHLIST_IMPORT_FAILURE, payload: error });
  }
}

// 🔹 Save Punchlist Saga
function* punchlistSaveSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_PUNCHLIST_SAVE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save Punchlist!");
    }

    Swal.fire("Success", response.message || "Punchlist saved successfully!", "success");
    yield put({ type: types.PUNCHLIST_SAVE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PUNCHLIST_SAVE_FAILURE, payload: error });
  }
}

function* fetchEmployeeMobilepunchSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_MOBILEPUNCH, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch Mobile Punch!');
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_FAILURE, payload: error.message });
  }
}
function* fetchEmployeeMobilepunchAppListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_MOBILEPUNCH_APPROVAL_LIST, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch Mobile Punch!');
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_FAILURE, payload: error.message });
  }
}
function* fetchEmployeeMobileBreaklistSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_MOBILE_BREAKINGS, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch Mobile Punch!');
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_FAILURE, payload: error.message });
  }
}

function* updateMobilePunchApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MOBILE_APPROVAL, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch Mobile Punch!');
    showToast({ icon: "Success", title: response.status, text: response.message });
    yield put({ type: types.SAVE_GENERATED_MOBILE_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    showToast({ icon: "error", title: "error", text: error.message });
    yield put({ type: types.SAVE_GENERATED_MOBILE_APPROVAL_FAILURE, payload: error.message })
  }
}

function* deleteMobilePunchSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DELETE_MOBILE_PUNCH,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Delete failed");
    }

    Swal.fire("Deleted!", response.message, "success");

    yield put({
      type: types.DELETE_MOBILE_PUNCH_SUCCESS,
      payload: action.payload.post_id,
    });
  } catch (error) {
    yield put({
      type: types.DELETE_MOBILE_PUNCH_FAILURE,
      payload: error.message,
    });
  }
}


export default function* biometricSaga() {
  yield takeLatest(types.FETCH_BIOMETRIC_DISCREPANCY_REQUEST, fetchBiometricDiscrepancySaga);
  yield takeLatest(types.FETCH_BIOMETRIC_DEVICE_PUNCH_REQUEST, fetchBiometricDevicePunchSaga);
  yield takeLatest(types.SAVE_BIOMETRIC_DEVICE_PUNCH_REQUEST, saveBiometricDevicePunchSaga);
  yield takeLatest(types.DISCREPANCY_SHIFT_UPDATE_REQUEST, discrepancyShiftUpdateSaga);

  yield takeLatest(types.DISCREPANCY_PUNCH_UPDATE_REQUEST, discrepancyPunchUpdateSaga);
  yield takeLatest(types.FETCH_SHIFT_PROCESS_REQUEST, fetchShiftProcessEmployeeSaga);
  yield takeLatest(types.SAVE_SHIFT_PROCESS_REQUEST, saveShiftProcessEmployeeSaga);
  yield takeLatest(types.FETCH_SHIFT_CHANGE_REQUEST, fetchShiftChangemployeeSaga);
  yield takeLatest(types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_REQUEST, fetchEmployeeShiftCodeSaga);
  yield takeLatest(types.SAVE_SHIFT_CHANGE_REQUEST, saveShiftChangeEmployeeSaga);
  yield takeLatest(types.FETCH_SHIFT_REMOVE_REQUEST, fetchEmployeeShiftSaga);
  yield takeLatest(types.REMOVE_SHIFT_REQUEST, removeShiftEmployeeSaga);

  yield takeLatest(types.PUNCHLIST_GET_TEMPLATE_REQUEST, punchlistGetTemplateSaga);
  yield takeLatest(types.PUNCHLIST_IMPORT_REQUEST, punchlistImportSaga);
  yield takeLatest(types.PUNCHLIST_SAVE_REQUEST, punchlistSaveSaga);

  yield takeLatest(types.FETCH_EMPLOYEE_MOBILE_PUNCH_REQUEST, fetchEmployeeMobilepunchSaga);
  yield takeLatest(types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_REQUEST, fetchEmployeeMobilepunchAppListSaga);
  yield takeLatest(types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_REQUESTS, fetchEmployeeMobileBreaklistSaga);
  yield takeLatest(types.SAVE_GENERATED_MOBILE_APPROVAL_REQUEST, updateMobilePunchApprovalSaga);
  yield takeLatest(types.DELETE_MOBILE_PUNCH, deleteMobilePunchSaga);
}
